// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"7749b9f3","138":"47e6b6a6","826":"2c93ccf6","861":"65965771"}[chunkId] + ".css";
};